"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _globals = require("../../../globals.js");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    border-style: none none solid;\n    box-sizing: content-box;\n    height: 0;\n    margin: 0;\n    width: 100%;\n    opacity: ", ";\n    transform: none;\n    transition-property: opacity;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Passive = _styledComponents["default"].hr(_templateObject(), function (props) {
  return props.theme;
}, function (props) {
  return props.state === _globals.STATE.DISABLED ? 0 : 1;
});

var _default = Passive;
exports["default"] = _default;